import { Dataset } from '../../types/types';

export const getItemsParamArray = (dataset: Dataset) => {
  const filteredItems: any[] = (dataset.items ?? []).filter(
    (item) => item.visible !== false
  );
  const items: string[] = filteredItems.map(({ name }) => name);

  filteredItems.forEach((item) => {
    if (item.formatItem && !items.includes(item.formatItem)) {
      items.push(item.formatItem);
    }
  });

  if (dataset.idItem && !items.includes(dataset.idItem)) {
    items.push(dataset.idItem);
  }

  if (dataset.labelItem && !items.includes(dataset.labelItem)) {
    items.push(dataset.labelItem);
  }

  if (dataset.styleItem && !items.includes(dataset.styleItem)) {
    items.push(dataset.styleItem);
  }

  dataset.additionalItems?.forEach((item) => {
    if (!items.includes(item)) {
      items.push(item);
    }
  });

  return items;
};
